import React from 'react';
import styled from 'styled-components';

import { HeaderText } from '/imports/refundPolicy/ui/atoms';

const Header = (props) => {
  return (
    <HeaderWrapper>
      <HeaderText>{props.children}</HeaderText>
    </HeaderWrapper>
  );
};

export default Header;

const HeaderWrapper = styled.div`
  width: 812px;
  margin: 0 auto;
  padding: 75px 0 25px 0;
  @media (max-width: 992px) {
    width: 90%;
  }
`;
